import { createSlice } from '@reduxjs/toolkit';
import VwKullaniciDTO from 'src/models/Base/Auth/VwKullaniciDTO';
import VwKullanicivtysgrupDTO from 'src/models/RolYetki/VwKullanicivtysgrupDTO';
import VwKullanicivtyslistDTO from 'src/models/RolYetki/VwKullanicivtyslistDTO';
import VwGnlKullaniciTarifeIptalDTO from 'src/models/Settings/Generals/VwGnlKullaniciTarifeIptalDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { KullaniciApi } from 'src/services/Kullanici/KullaniciApi';

interface IKullaniciVTYSGrup {
  kullaniciTanimActiveRow?: VwKullaniciDTO;
  kullaniciVtysActiveRow?: VwKullanicivtysgrupDTO;
  fetchKullaniciVtysGrup: boolean;
  activeVtysGrupId: number;
  kullaniciVtysGrupList: Array<VwKullanicivtysgrupDTO>;
  kullaniciVtysList: Array<VwKullanicivtyslistDTO>;
  reloadVtysGrupList: boolean;
}

export const KullaniciVTYSGrupSlice = createSlice<
  IKullaniciVTYSGrup,
  MapReducerPayloads<
    IKullaniciVTYSGrup,
    {
      setKullaniciTanimActiveRow?: VwKullaniciDTO;
      setKullaniciVtysActiveRow?: VwKullanicivtysgrupDTO;
      setFetchKullaniciVtysGrup: boolean;
      setActiveVtysGrupId: number;
      setKullaniciVtysGrupList: Array<VwKullanicivtysgrupDTO>;
      setReloadVtysGrupList: boolean;
      setKullaniciVtysList: Array<VwKullanicivtyslistDTO>;
    }
  >
>({
  name: 'KullaniciVTYSGrupState',
  initialState: {
    kullaniciTanimActiveRow: new VwKullaniciDTO(),
    kullaniciVtysActiveRow: new VwKullanicivtysgrupDTO(),
    fetchKullaniciVtysGrup: false,
    activeVtysGrupId: 3, //Default kurumları listeleyecegiz
    kullaniciVtysGrupList: [],
    reloadVtysGrupList: false,
    kullaniciVtysList: []
  },
  reducers: {
    setKullaniciTanimActiveRow: (state, action) => {
      state.kullaniciTanimActiveRow = action.payload;
    },
    setKullaniciVtysActiveRow: (state, action) => {
      state.kullaniciVtysActiveRow = action.payload;
    },
    setFetchKullaniciVtysGrup: (state, action) => {
      state.fetchKullaniciVtysGrup = action.payload;
    },
    setActiveVtysGrupId: (state, action) => {
      state.activeVtysGrupId = action.payload;
    },
    setKullaniciVtysGrupList: (state, action) => {
      state.kullaniciVtysGrupList = action.payload;
    },
    setReloadVtysGrupList: (state, action) => {
      state.reloadVtysGrupList = action.payload;
    },
    setKullaniciVtysList: (state, action) => {
      state.kullaniciVtysList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(KullaniciApi.endpoints.KullaniciVTYSList.matchFulfilled, (state, action) => {
      state.kullaniciVtysList = action.payload;
      return state;
    });
    builder.addMatcher(KullaniciApi.endpoints.VtysGrupList.matchFulfilled, (state, action) => {
        state.kullaniciVtysGrupList = action.payload;
        return state;
    });
  }
});
